import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { SwagUpIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/swagUp';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toSwagUpConfigDoc = generateToDocFn<SwagUpIntegrationConfig>();

const COLLECTION = FS.swagUpIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const swagUpConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toSwagUpConfigDoc
);

export const useSwagUpConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(swagUpConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<SwagUpIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            accessToken: '',
            refreshToken: '',
            expiryDate: 0
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeSwagUpConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
